export const uniq = (array) => array.filter((item, index, self) => index === self.findIndex((t) => t.id === item.id && t.label === item.label));
export const getSuggestions = (items, search) => search
    ? search.length
        ? uniq(items.filter((suggestion) => suggestion.label.toLowerCase().includes(search.toLowerCase()) && suggestion.label !== search))
        : []
    : uniq(items);
